import { render, staticRenderFns } from "./TitleComponent.vue?vue&type=template&id=6b48d64f&"
import script from "./TitleComponent.vue?vue&type=script&lang=js&"
export * from "./TitleComponent.vue?vue&type=script&lang=js&"
import style0 from "./TitleComponent.vue?vue&type=style&index=0&id=6b48d64f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports